require('lightcase/src/js/lightcase')

# Function "Ready"
ready = (fn) ->
  if (if document.attachEvent then document.readyState == 'complete' else document.readyState != 'loading')
    fn()
  else
    document.addEventListener 'DOMContentLoaded', fn
  return

ready ->
  $('a[data-rel^=lightcase]').lightcase
    video:
      width: 1280
      height: 960
      poster: ''
      preload: 'auto'
      controls: true
      autobuffer: true
      autoplay: true
      loop: false
    swipe: true
    liveResize: true
    mobileMatchExpression: /(iphone|ipod|ipad|android|blackberry|symbian)/
    fullScreenModeForMobile: true
    overlayOpacity: .95
    closeOnOverlayClick: true
    shrinkFactor: .9
    maxWidth: 1280
    maxHeight: 960
  return



// WEBPACK FOOTER //
// ./Components/lightcase.coffee